import { getCurrentUser } from '@creditsights/api-ui-web';
import { useQuery, UseQueryResult } from 'react-query';
import { USER_INTERESTS_CACHE_KEY } from '../../Constants';
import { UserInterests } from '../../models/User';
import { fetchUserInterests } from '../../services/user.service';

interface UseFetchInterestsOptions {
  enabled?: boolean;
}

export default ({ enabled = true }: UseFetchInterestsOptions): UseQueryResult<UserInterests, Error> => {
  const { userId } = getCurrentUser();
  return useQuery([USER_INTERESTS_CACHE_KEY, userId], async () => fetchUserInterests(), { enabled });
};
